import { Component, EventEmitter, OnChanges } from '@angular/core';
import {OrganizationDetailService} from '../organization-detail.service';
import { BaseComponent } from '../../../shared/base-components/base.component';
import {OrganizationDetailViewModel} from '../../models/views/organization-detail-view.model';
import {CustomerIdentification} from '../../models/customer-identification.model';
import { CustomerType } from '../../models/enums/customer-type.enum';
import { EinPipe } from '../../shared/pipes/ein.pipe';
import { OrganizationDetailModalContext, OrganizationDetailModalComponent } from './organization-customer-details-modal.component';
import { MvdModalService } from '../../../shared/services/modal/mvd-modal.service';

@Component({
    selector: 'organization-customer-details',
    templateUrl: './organization-customer-details.html',
    inputs: ['customerNumber', 'details'],
    outputs: ['customerStatusTypeIdChange']
})

export class OrganizationCustomerDetailsComponent extends BaseComponent implements OnChanges {
    public details: any[];
    public customerNumber: number;
    public organizationDetails: OrganizationDetailViewModel;
    public cols: any[];
    private OrgEIN: string;
    private customerTypes = new CustomerType();

    private CUSTOMER_IDENTIFICATION_TYPE_EIN = 6;
    public customerStatusTypeIdChange: EventEmitter<number> = new EventEmitter<number>();

    constructor(private service: OrganizationDetailService,
        private ein: EinPipe,
        public modalService: MvdModalService) {
        super();
    }

    ngOnInit() {
        if (this.customerNumber != null) {
            this.getDetails(this.customerNumber);
        }

        this.cols = [
            { field: 'customerType', header: 'Type' },
            { field: 'customerNumber', header: 'Customer Number' },
            { field: 'ein', header: 'EIN', type: this.ein }
        ];
    }

    ngOnChanges() {
        if (this.customerNumber != null) {
            this.getDetails(this.customerNumber);
        }
    }

    getDetails(customerNumber) {
        let ein: string;
        this.service.getData(customerNumber)
            .subscribe(result => {
                this.organizationDetails = result;
            },
            e => this.handleValidationResult(e),
            () => {
                // Get Identifications
                for (var x = 0; x < this.organizationDetails.identifications.length; x++) {
                    var identification: CustomerIdentification;
                    identification = this.organizationDetails.identifications[x];

                    switch (identification.customerIdentificationTypeId) {
                        case this.CUSTOMER_IDENTIFICATION_TYPE_EIN:
                            ein = identification.customerIdentificationValue;
                            this.OrgEIN = identification.customerIdentificationValue;
                            break;
                        default:
                            break;
                    }
                }

                this.details = [];
                this.details.push({'customerType': this.getValues(this.organizationDetails.customerTypeId, this.customerTypes), 'customerNumber': this.organizationDetails.id, 'ein': ein});
            });
    }

    getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            return types.FromId(id).displayValue;
        } else {
            return '';
        }
    }

    editOrg() {
        const data = new OrganizationDetailModalContext(this.customerNumber, this.OrgEIN, this.organizationDetails.statusTypeId);
        const dialogRef = this.modalService.open(OrganizationDetailModalComponent, data);

        dialogRef.afterClosed()
            .subscribe(
                result => {
                    this.getDetails(this.customerNumber);
                    this.customerStatusTypeIdChange.emit(result);
                }
            );
    }
}
